import React from 'react';
import LazyPageLoader from '../cmp/LazyPageLoader';

const Page = React.lazy(()=>import('./SettingsPage'))

export default function LazySettingsPage(props){
    return <React.Suspense fallback={<LazyPageLoader />}>
        <Page />
    </React.Suspense>
}
